import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Tooltip,
} from '@mui/material';

const POS_FIELDS = [
  { label: 'Feed', field: 'intercard_pos_transactions_rows_feed' },
  { label: 'Staging', field: 'intercard_pos_transactions_rows_staging' },
  { label: 'Failed', field: 'intercard_pos_transactions_rows_failed' },
  { label: 'Success', field: 'intercard_pos_transactions_rows_success' },
  { label: 'Unmapped', field: 'intercard_pos_transactions_rows_unmapped' },
  { label: 'Inserted', field: 'intercard_pos_transactions_rows_inserted' },
  { label: 'Updated', field: 'intercard_pos_transactions_rows_updated' },
  { label: 'Deleted', field: 'intercard_pos_transactions_rows_deleted' },
  { label: 'Reinstated', field: 'intercard_pos_transactions_rows_reinstated' },
  { label: 'Error Text', field: 'intercard_pos_transactions_error_text', isError: true },
  { label: 'Error Detail', field: 'intercard_pos_transactions_error_detail', isError: true },
];

const TELLER_FIELDS = [
  { label: 'Feed', field: 'intercard_teller_transactions_rows_feed' },
  { label: 'Staging', field: 'intercard_teller_transactions_rows_staging' },
  { label: 'Failed', field: 'intercard_teller_transactions_rows_failed' },
  { label: 'Success', field: 'intercard_teller_transactions_rows_success' },
  { label: 'Unmapped', field: 'intercard_teller_transactions_rows_unmapped' },
  { label: 'Inserted', field: 'intercard_teller_transactions_rows_inserted' },
  { label: 'Updated', field: 'intercard_teller_transactions_rows_updated' },
  { label: 'Deleted', field: 'intercard_teller_transactions_rows_deleted' },
  { label: 'Reinstated', field: 'intercard_teller_transactions_rows_reinstated' },
  { label: 'Error Text', field: 'intercard_teller_transactions_error_text', isError: true },
  { label: 'Error Detail', field: 'intercard_teller_transactions_error_detail', isError: true },
];

const TXN_FIELDS = [
  { label: 'Feed', field: 'intercard_transactions_rows_feed' },
  { label: 'Staging', field: 'intercard_transactions_rows_staging' },
  { label: 'Failed', field: 'intercard_transactions_rows_failed' },
  { label: 'Success', field: 'intercard_transactions_rows_success' },
  { label: 'Unmapped', field: 'intercard_transactions_rows_unmapped' },
  { label: 'Inserted', field: 'intercard_transactions_rows_inserted' },
  { label: 'Updated', field: 'intercard_transactions_rows_updated' },
  { label: 'Deleted', field: 'intercard_transactions_rows_deleted' },
  { label: 'Reinstated', field: 'intercard_transactions_rows_reinstated' },
  { label: 'Error Text', field: 'intercard_transactions_error_text', isError: true },
  { label: 'Error Detail', field: 'intercard_transactions_error_detail', isError: true },
];

const BASE_CELL_WIDTH = 80;
const ERROR_CELL_WIDTH = 180;

const renderHorizontalTable = (title, fields, intercardInfo) => (
  <TableContainer component={Paper} sx={{ mb: 2, borderBottom: '1px solid #ccc' }}>
    <Typography variant="subtitle1" sx={{ p: 2, fontWeight: 600 }}>
      {title}
    </Typography>
    <Table size="small" sx={{ border: '1px solid #ccc', tableLayout: 'fixed' }}>
      <TableHead>
        <TableRow>
          {fields.map(({ label, field }) => (
            <TableCell
              key={field}
              sx={{
                border: '1px solid #ccc',
                fontWeight: 600,
                textAlign: 'center',
                verticalAlign: 'middle',
                p: 1,
                width: label.toLowerCase().includes('error') ? ERROR_CELL_WIDTH : BASE_CELL_WIDTH,
              }}
              align="center"
            >
              {label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          {fields.map(({ field, isError }) => {
            const content =
              intercardInfo?.[field] !== null && intercardInfo?.[field] !== undefined && intercardInfo?.[field] !== ''
                ? intercardInfo[field].toString()
                : '-';

            const textNode = (
              <Tooltip title={content} arrow>
                <Typography
                  component="span"
                  sx={{
                    display: 'block',
                    width: 165,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: isError ? '0.68rem' : '0.70rem',
                    fontWeight: isError ? 500 : 500,
                    lineHeight: 1.1,
                    m: 0,
                    p: 0,
                  }}
                >
                  {content}
                </Typography>
              </Tooltip>
            );
            return (
              <TableCell
                key={field}
                sx={{
                  border: '1px solid #ccc',
                  color: isError ? 'red' : 'inherit',
                  fontWeight: isError ? 600 : 'inherit',
                  backgroundColor:
                    isError &&
                    intercardInfo?.[field] !== null &&
                    intercardInfo?.[field] !== undefined &&
                    intercardInfo?.[field] !== ''
                      ? '#fff5f5'
                      : 'inherit',
                  textAlign: 'center',
                  verticalAlign: 'middle',
                }}
                style={{ padding: '8px' }}
                align="center"
              >
                {isError && content != '-' ? textNode : content}
              </TableCell>
            );
          })}
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
);

const IntercardTable = ({ intercardInfo }) => (
  <>
    {(() => {
      const tables = {
        'Intercard Asset': ['Game Revenue Transactions', TXN_FIELDS],
        'Intercard Teller': ['Teller Transactions', TELLER_FIELDS],
        'Intercard Point of Sale': ['POS Transactions', POS_FIELDS],
      };

      const config = tables[intercardInfo?.feed_source_name];

      return config ? renderHorizontalTable(config[0], config[1], intercardInfo) : null;
    })()}
  </>
);

export default IntercardTable;
